webpackJsonp([178813192718937],{

/***/ 838:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(13);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SEO = __webpack_require__(54);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _SiteConfig = __webpack_require__(12);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Starter = __webpack_require__(55);
	
	var _Starter2 = _interopRequireDefault(_Starter);
	
	var _PostListing = __webpack_require__(53);
	
	var _PostListing2 = _interopRequireDefault(_PostListing);
	
	var _FadeInWrapper = __webpack_require__(7);
	
	var _FadeInWrapper2 = _interopRequireDefault(_FadeInWrapper);
	
	var _GriegMFM = __webpack_require__(71);
	
	var _GriegMFM2 = _interopRequireDefault(_GriegMFM);
	
	var _GriegPageImg = __webpack_require__(1511);
	
	var _GriegPageImg2 = _interopRequireDefault(_GriegPageImg);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Artister = function (_React$Component) {
	  _inherits(Artister, _React$Component);
	
	  function Artister() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Artister);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      artistType: 'alle'
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Artister.prototype.getTagsList = function getTagsList() {
	    var tagList = [];
	    this.props.data.allMarkdownRemark.edges.forEach(function (postEdge) {
	      tagList.push(postEdge.node.frontmatter.tags);
	    });
	    var sortByFrequency = function sortByFrequency(array) {
	      var frequency = {};
	      array.forEach(function (value) {
	        frequency[value] = 0;
	      });
	
	      var uniques = array.filter(function (value) {
	        return ++frequency[value] == 1;
	      });
	
	      return uniques.sort(function (a, b) {
	        return frequency[b] - frequency[a];
	      });
	    };
	    return sortByFrequency(tagList);
	    {/*
	      let toArray = [];
	      let tezt = () => {for (const x of tagList) { toArray.push(x) };}
	      tezt();
	      toArray = toArray.reduce(function(a, b){
	       return a.concat(b);
	       }
	      );
	      let fastUniq = a => {
	       var seen = {};
	       var out = [];
	       var len = a.length;
	       var j = 0;
	       for(var i = 0; i < len; i++) {
	         var item = a[i];
	         if(seen[item] !== 1) {
	            seen[item] = 1;
	            out[j++] = item;
	          }
	       }
	       return out;
	      }
	      return fastUniq(toArray);
	      */}
	  };
	
	  Artister.prototype.handleArtistClick = function handleArtistClick(e) {
	    if (this.state.artistType !== e.target.id) {
	      this.setState({
	        artistType: e.target.id
	      });
	    }
	  };
	
	  Artister.prototype.render = function render() {
	    var _this2 = this;
	
	    var postEdges = this.props.data.allMarkdownRemark.edges;
	    var tagList = this.getTagsList();
	    var style = {
	      background: "#a0a0a0"
	    };
	    return _react2.default.createElement(
	      "div",
	      { className: " artist-container" },
	      _react2.default.createElement(_reactHelmet2.default, { title: "Artister | #NRKGRIEG" }),
	      _react2.default.createElement(_SEO2.default, { postEdges: postEdges, pageImg: _GriegPageImg2.default }),
	      _react2.default.createElement(
	        _Starter2.default,
	        { height: "2" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "#NRKGRIEG"
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Artister"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "flex center tag-container" },
	        _react2.default.createElement(
	          "h4",
	          {
	            onClick: function onClick(e) {
	              return _this2.handleArtistClick(e);
	            },
	            id: "alle",
	            style: this.state.artistType === 'alle' ? style : null },
	          "Alle"
	        ),
	        /* Your post list here. */
	        tagList.map(function (item, i) {
	          return _react2.default.createElement(
	            "h4",
	            {
	              onClick: function onClick(e) {
	                return _this2.handleArtistClick(e);
	              },
	              id: item,
	              key: i,
	              style: _this2.state.artistType === item ? style : null },
	            item
	          );
	        })
	      ),
	      _react2.default.createElement(_PostListing2.default, {
	        postEdges: postEdges,
	        view: "artistView",
	        title: "Artister",
	        artistType: this.state.artistType,
	        img: _GriegMFM2.default
	      })
	    );
	  };
	
	  return Artister;
	}(_react2.default.Component);
	
	exports.default = Artister;
	
	/* eslint no-undef: "off"*/
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 1511:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/GriegPageImg.bc7e28ce.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-artister-jsx-629d9c56683a55ea501d.js